Vue.component('ack-partners', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-partners',
    mixins: [languageMixins],
    created() {
      
    },
    mounted() {
      appLog.log('ack-partners mounted')
      this.setPageIsLoading(false)
    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }

    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']),
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
    },
    data() {
      return {
        pageId: 'partners-page',
        partners: [
            { name: '3shape', url: 'https://www.3shape.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/3shape.png?v=1656400700' },
            { name: 'arma', url: 'https://armadental.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Partner_Logos_ARMA.png?v=1714721284' },
            { name: 'argen', url: 'https://argen.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ARGEN-logo.png?v=1653471593' },
            { name: 'bego', url: 'https://www.bego.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/BEGO-logo_1ab4908a-63a6-45b8-88a2-1f0f2a5455a1.png?v=1653471593' },
            //{ name: 'cadray', url: 'https://www.cad-ray.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/cadray.png?v=1656400700' },
            { name: 'clinux', url: 'https://www.clinux.pro/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Partner_Logos_CLINUX.png?v=1714723674' },
            { name: 'dentca', url: 'https://www.dentca.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/logo_Dentca_color.png?v=1636102183' },
            { name: 'deltamed', url: 'https://deltamed.pro/en/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/logo_Dentca_color.png?v=1636102183' },
            { name: 'dentona', url: 'https://dentona.de/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/DENTONA-logo.png?v=1653472215' },
            { name: 'dmg', url: 'https://www.dmg-dental.com/en/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/DMG-logo.png?v=1653536206' },
            { name: 'dreve', url: 'https://dreve.de/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/logo_DREVE_color.png?v=1636102183' },
            { name: 'dtech', url: 'https://dtechasia.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Home_V4_d-tech.png?v=1699002751' },
            { name: 'exocad', url: 'https://exocad.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/exocad.png?v=1656400700' },
            { name: 'gc', url: 'https://www.gcamerica.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/logo_GC_color.png?v=1636102183' },
            { name: 'harz', url: 'https://harzlabs.ru/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/HARZ-Labs-logo.png?v=1653471593' },
            { name: 'hpdent', url: 'https://hp-dent.com/en/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/HPDENT-logo-bgb.png?v=1653542983' },
            { name: 'ictus', url: '#', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ICTUS-DENTAL-logo.png?v=1653536206' },
            { name: 'keystone', url: 'https://keystoneindustries.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/logo_KeyStone_color.png?v=1636102183' },
            { name: 'mack4d', url: 'https://www.mack4d.de/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/logo_MACK4D_color.png?v=1636102183' },
            //{ name: 'merz', url: 'https://www.merz.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/logo_MERZ_color.png?v=1636102183' },
            { name: 'medit', url: 'https://www.medit.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/mdeit.png?v=1656400700' },
            { name: 'nextdent', url: 'https://nextdent.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/NEXT-DENT-logo.png?v=1653538176' },
            { name: 'nyte', url: 'https://www.nyte3d.de/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/NYTE3D-logo.png?v=1653536206' },
            { name: 'pac-dent', url: 'https://pac-dent.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Partner_Logos_Pac-Dent.png?v=1711000964' },
            { name: 'pro3dure', url: 'https://www.pro3dure.com/en/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Partner_Logos_pro3dure.png?v=1711000964' },
            { name: 'saremco', url: 'https://www.saremco.ch/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/logo_Saremco_color.png?v=1655368471' },
            { name: 'smilefy', url: 'https://smilefy.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/smilefy.png?v=1656400700' },
            { name: 'shera', url: 'https://shera.de/en/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Partner_Logos_SHERA.png?v=1714721283' },
            { name: 'straumann', url: 'https://www.straumann.com/en/dental-professionals.html', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Straumann_Logo_svg.png?v=1714625116' },
            { name: 'whipmix', url: 'https://www.whipmix.com/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Partner_Logos_Whip_Mix.png?v=1714721284' },
            { name: 'yamahachi', url: 'https://yamahachi-dental.co.jp/en/', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/YAMAHACHI_LOGO_NEW.png?v=1715233730' },
            { name: 'voco', url: 'https://www.voco.dental/us/home.aspx', logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/VOCO-logo.png?v=1653536206' },
        ]
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading'])
      //...Vuex.mapActions('sliders', ['getSlideList'])




    },
    beforeDestroy() {

    },
    watch: {

      data1: {
        handler() {



        },
        deep: false
      }
    }
  })